import {
  SearchByPropertyResult,
  SearchByNameResultWithSearchCriteria,
  SearchByOtherResult,
} from './models';
import { SearchByMultiResult } from './models/result/SearchByMultiResult';

export interface SearchState {
  propertyData: SearchByPropertyResult | null;
  nameData: SearchByNameResultWithSearchCriteria | null;
  otherData: SearchByOtherResult | null;
  multiData: SearchByMultiResult | null;
  loading: boolean;
}

export const SEARCH_CLEAR = 'SEARCH_CLEAR';
export const SEARCH_LOADING = 'SEARCH_LOADING';
export const SEARCH_PROPERTY_ADD = 'SEARCH_PROPERTY_ADD';
export const SEARCH_NAME_ADD = 'SEARCH_NAME_ADD';
export const SEARCH_OTHER_ADD = 'SEARCH_OTHER_ADD';
export const SEARCH_MULTI_ADD = 'SEARCH_MULTI_ADD';
export const SEARCH_IS_SELECTED_UPDATE = 'SEARCH_IS_SELECTED_UPDATE';
export const SEARCH_EXPORT_TYPE_UPDATE = 'SEARCH_EXPORT_TYPE_UPDATE';
export const SEARCH_SHOW_REFERNCES_UPDATE = 'SEARCH_SHOW_REFERNCES_UPDATE';
export const SEARCH_TOGGLE_SELECT_ALL = 'SEARCH_TOGGLE_SELECT_ALL';

interface SearchClearAction {
  type: typeof SEARCH_CLEAR;
}

interface SearchToggleSelectAllAction {
  type: typeof SEARCH_TOGGLE_SELECT_ALL;
  payload: any;
}

interface SearchLoadingAction {
  type: typeof SEARCH_LOADING;
  payload: boolean;
}

interface SearchPropertyAddAction {
  type: typeof SEARCH_PROPERTY_ADD;
  payload: SearchByPropertyResult;
}

interface SearchNameAddAction {
  type: typeof SEARCH_NAME_ADD;
  payload: SearchByNameResultWithSearchCriteria;
}

interface SearchOtherAddAction {
  type: typeof SEARCH_OTHER_ADD;
  payload: SearchByOtherResult;
}

interface SearchMultiAddAction {
  type: typeof SEARCH_MULTI_ADD;
  payload: SearchByMultiResult;
}

export type DocumentTypeName =
  | 'recordedDocuments'
  | 'liens'
  | 'federalTaxLiens'
  | 'uniformCommercialCodes'
  | 'assessment';

export type DataTypeName =
  | 'propertyData'
  | 'nameData'
  | 'otherData'
  | 'multiData';

export type ResultTypeName =
  | 'propertyResult'
  | 'nameResult'
  | 'otherResult'
  | undefined;

export interface SearchIsSelectedUpdate {
  type: typeof SEARCH_IS_SELECTED_UPDATE;
  payload: {
    dataTypeName: DataTypeName;
    documentType: DocumentTypeName;
    guid: string;
    isSelected: boolean;
    resultItemIndex: number;
    resultType: ResultTypeName;
  };
}

export interface SearchShowReferncesUpdate {
  type: typeof SEARCH_SHOW_REFERNCES_UPDATE;
  payload: {
    dataTypeName: DataTypeName;
    documentType: DocumentTypeName;
    showReferences: boolean;
    resultItemIndex: number;
    resultType: ResultTypeName;
  };
}

export interface SearchExportTypeUpdate {
  type: typeof SEARCH_EXPORT_TYPE_UPDATE;
  payload: {
    dataTypeName: DataTypeName;
    documentType: DocumentTypeName;
    exportType: string;
    resultItemIndex: number;
    resultType: ResultTypeName;
  };
}

export type SearchDataActionTypes =
  | SearchClearAction
  | SearchLoadingAction
  | SearchPropertyAddAction
  | SearchNameAddAction
  | SearchOtherAddAction
  | SearchMultiAddAction
  | SearchIsSelectedUpdate
  | SearchShowReferncesUpdate
  | SearchExportTypeUpdate
  | SearchToggleSelectAllAction;
